export const selectTimeslots = state => ({
    error: state.doctors.error,
    isLoading: state.doctors.isLoading,
    timeslots: state.doctors.timeslots,
    timetable: state.doctors.timetable,
    timeslotsBranch: state.doctors.timeslotsBranch,
    timeslotsSpeciality: state.doctors.timeslotsSpeciality,
    timeslotDate: state.doctors.timeslotDate,
    timetableData: state.doctors.timetableData,
    timetableLoaded: state?.doctors?.timetableLoaded,
});
